import React from "react";
import {
  Box,
  Typography,
  Paper,
  Divider,
  LinearProgress,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import ItemRenderer from "../items/ItemRenderer";

/**
 * PageContent component - renders the items for the current page
 * @param {Object} props
 * @param {Object} props.page - Current page object with items
 * @param {Function} props.onUpdateItem - Callback when an item is updated
 * @param {boolean} props.editable - Whether items are editable
 * @param {boolean} props.showProgress - Whether to show page progress
 */
const PageContent = ({
  page,
  onUpdateItem,
  editable = true,
  showProgress = true,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  if (!page) {
    return (
      <Paper
        elevation={0}
        sx={{
          p: 3,
          borderRadius: 2,
          bgcolor: "background.paper",
          border: "1px solid",
          borderColor: "divider",
          textAlign: "center",
        }}
      >
        <Typography variant="body1" color="text.secondary">
          No page selected
        </Typography>
      </Paper>
    );
  }

  const {
    items = [],
    completedItems = 0,
    totalItems = 0,
    title,
    assetSerialNumber,
    workOrderLineItemId,
  } = page;
  const pageProgress =
    totalItems > 0 ? Math.round((completedItems / totalItems) * 100) : 0;

  const handleItemUpdate = (itemId, updates) => {
    if (onUpdateItem) {
      console.log(workOrderLineItemId);
      onUpdateItem(itemId, workOrderLineItemId, updates);
    }
  };

  return (
    <Paper
      elevation={0}
      sx={{
        p: { xs: 2, sm: 3 },
        borderRadius: 2,
        bgcolor: "background.paper",
        border: "1px solid",
        borderColor: "divider",
      }}
    >
      {/* Page Header */}
      {/* <Box sx={{ mb: 3 }}>
        <Typography
          variant="h6"
          component="h2"
          gutterBottom
          sx={{
            fontSize: { xs: "1.1rem", sm: "1.25rem" },
            fontWeight: 600,
          }}
        >
          Asset {assetSerialNumber}
        </Typography>

        {showProgress && (
          <Box sx={{ mb: 2 }}>
            <Box
              sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}
            >
              <Typography variant="body2" color="text.secondary">
                Page Progress
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {completedItems}/{totalItems} items ({pageProgress}%)
              </Typography>
            </Box>
            <LinearProgress
              variant="determinate"
              value={pageProgress}
              sx={{
                height: 6,
                borderRadius: 3,
                bgcolor: theme.palette.grey[200],
                "& .MuiLinearProgress-bar": {
                  borderRadius: 3,
                  bgcolor:
                    pageProgress === 100
                      ? theme.palette.success.main
                      : theme.palette.primary.main,
                },
              }}
            />
          </Box>
        )}

        <Divider />
      </Box> */}

      {/* Page Items */}
      <Box>
        {items.length > 0 ? (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            {items.map((item, index) => (
              <Box
                key={item.id}
                sx={{
                  position: "relative",
                  "&:not(:last-child)": {
                    mb: 1,
                  },
                }}
              >
                {/* Item Number Badge */}
                {/* <Box
                  sx={{
                    position: "absolute",
                    left: -8,
                    top: 8,
                    width: 24,
                    height: 24,
                    borderRadius: "50%",
                    bgcolor: item.completed
                      ? theme.palette.success.main
                      : theme.palette.grey[300],
                    color: item.completed
                      ? "white"
                      : theme.palette.text.secondary,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "0.75rem",
                    fontWeight: "bold",
                    zIndex: 1,
                    border: `2px solid ${theme.palette.background.paper}`,
                    ...(isMobile && {
                      display: "none", // Hide on mobile to save space
                    }),
                  }}
                >
                  {index + 1}
                </Box> */}

                {/* Item Content */}
                <Box
                  sx={{
                    ml: isMobile ? 0 : 3,
                    position: "relative",
                  }}
                >
                  <ItemRenderer
                    item={item}
                    onUpdate={handleItemUpdate}
                    onDelete={() => {}} // Disable delete in page view
                    editable={editable}
                    draggable={false}
                    isTemplateView={false}
                  />
                </Box>
              </Box>
            ))}
          </Box>
        ) : (
          <Box
            sx={{
              py: 4,
              textAlign: "center",
              color: "text.secondary",
            }}
          >
            <Typography variant="body1" sx={{ fontStyle: "italic" }}>
              No items in this page
            </Typography>
          </Box>
        )}
      </Box>

      {/* Page Summary */}
      {/* {items.length > 0 && (
        <Box
          sx={{
            mt: 3,
            pt: 2,
            borderTop: `1px solid ${theme.palette.divider}`,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 1,
          }}
        >
          <Typography variant="body2" color="text.secondary">
            {completedItems} of {totalItems} items completed
          </Typography>

          {pageProgress === 100 && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                color: theme.palette.success.main,
                fontWeight: 600,
              }}
            >
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                ✓ Page Complete
              </Typography>
            </Box>
          )}
        </Box>
      )} */}
    </Paper>
  );
};

export default PageContent;
